import { DeleteIcon } from '@chakra-ui/icons';

import {
  Button,
  Flex,
  Input,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import {
  tetrathlonManEventListType,
  tetrathlonManEventType,
} from '../common/types';
import { calcRecordByName, calcScoreByName } from './components/calcPoint';
import { eventNameDict } from './components/eventNameDict';
import { HowToName } from './components/howToName';
import { HowToUse } from './components/howToUse';
import { Links } from './components/links';
import { ScoreInput } from './components/scoreInput';
import { TextBox } from './components/textbox';

export const CalculatorTetrathlonManSave = () => {
  const [records, setRecords] = useState<tetrathlonManEventListType>({
    ii0h: '',
    sp: '',
    hj: '',
    A00: '',
  });

  // 得点もinputでいじるのでこれも箱として良い
  const [points, setPoints] = useState<tetrathlonManEventListType>({
    ii0h: '',
    sp: '',
    hj: '',
    A00: '',
  });

  // 種目名を入れるとそれより前に行われたやつを全部足す関数
  const calcTotalPoint = (EventName: tetrathlonManEventType) => {
    let totalPoint = 0;
    for (const event in points) {
      const score = Number(points[event as tetrathlonManEventType]) || 0;
      totalPoint += score;
      if (event === EventName) {
        break;
      }
    }
    return totalPoint;
  };

  const handleChange =
    (key: tetrathlonManEventType) =>
    (score: React.ChangeEvent<HTMLInputElement>) => {
      const record = Number(score.target.value);
      const newRecords = { ...records, [key]: record };
      const calucalatedPoint = calcScoreByName(key, record);
      const newPoints = { ...points, [key]: calucalatedPoint };

      setRecords(newRecords);
      setPoints(newPoints);

      // 🔽 自動保存
      localStorage.setItem(
        'TetraManData_lastUsed',
        JSON.stringify({
          name: 'last-used',
          data: newRecords,
          point: newPoints,
        })
      );
    };

  const handlePointChangeParent =
    (key: tetrathlonManEventType) =>
    (result: React.ChangeEvent<HTMLInputElement>) => {
      const point = Number(result.target.value);
      const newPoints = { ...points, [key]: point };
      const score = calcRecordByName(key, point);
      const newRecords = { ...records, [key]: score };

      setPoints(newPoints);
      setRecords(newRecords);

      // 🔽 自動保存
      localStorage.setItem(
        'TetraManData_lastUsed',
        JSON.stringify({
          name: 'last-used',
          data: newRecords,
          point: newPoints,
        })
      );
    };

  const reset = () => {
    setPoints({
      ii0h: '',
      sp: '',
      hj: '',
      A00: '',
    });
    setRecords({
      ii0h: '',
      sp: '',
      hj: '',
      A00: '',
    });
  };
  const eventList = Object.keys(records) as tetrathlonManEventType[];

  //ここからSAVE用のモーダル部分

  const {
    isOpen: isOpenLoad,
    onOpen: onOpenLoad,
    onClose: onCloseLoad,
  } = useDisclosure();
  const [inputName, setInputName] = useState<string>('');
  const [dataList, setDataList] = useState<string[]>([]);
  const [selectedData, setSelectedData] = useState<string | null>(null);

  // ローカルストレージからデータを取得して初期化
  useEffect(() => {
    const storageData = localStorage.getItem('TetraManData');

    if (storageData) {
      const parsedData: {
        name: string;
        data: tetrathlonManEventListType;
        point: tetrathlonManEventListType;
      }[] = JSON.parse(storageData);
      const savedData: string[] = parsedData.map((item) => item.name);
      setDataList(savedData);
    }

    // 🔽 自動復元処理を追加
    const lastUsed = localStorage.getItem('TetraManData_lastUsed');
    if (lastUsed) {
      try {
        const parsed = JSON.parse(lastUsed);
        if (parsed.data && parsed.point) {
          setRecords(parsed.data);
          setPoints(parsed.point);
        }
      } catch (e) {
        console.error('TetraManData_lastUsed 読み込み失敗:', e);
      }
    }
  }, []);

  interface Data {
    name: string;
    data: tetrathlonManEventListType;
    point: tetrathlonManEventListType;
  }

  const saveData = (): void => {
    if (inputName.trim() !== '') {
      const newData: Data = {
        name: inputName,
        data: records,
        point: points,
      };
      const existingData: Data[] = JSON.parse(
        localStorage.getItem('TetraManData') || '[]'
      ) as Data[];

      const isNameExist = existingData.some(
        (data: Data) => data.name === inputName
      );

      if (!isNameExist) {
        // 名前付き保存
        localStorage.setItem(
          'TetraManData',
          JSON.stringify([...existingData, newData])
        );

        // 🔽 自動復元用にも保存（last-used）
        localStorage.setItem('TetraManData_lastUsed', JSON.stringify(newData));

        setDataList((prevDataList: string[]) => [...prevDataList, inputName]);
        setInputName('');
      } else {
        alert('この名前は使用されています');
      }
    }
  };

  const deleteData = (deletedItem: string) => {
    const storageData = localStorage.getItem('TetraManData');
    let parsedData = null;
    if (storageData) {
      parsedData = JSON.parse(storageData) as {
        name: string;
        data: tetrathlonManEventListType;
        point: tetrathlonManEventListType;
      }[];
    }
    if (!parsedData) return;

    const updatedDataList = parsedData.filter(
      (item) => item.name !== deletedItem
    );
    const dataNameList = updatedDataList.map((d) => d.name);
    setDataList(dataNameList);
    localStorage.setItem('TetraManData', JSON.stringify(updatedDataList)); // 最初の要素を保存するか、データがない場合は空文字列を保存
    // 削除されたデータが選択されていた場合、選択をリセット
    if (selectedData === deletedItem) {
      setSelectedData(null);
    }
  };

  const showSelectedData = (selectedItem: string) => {
    const storageData = localStorage.getItem('TetraManData');

    if (storageData) {
      const parsedData: {
        name: string;
        data: tetrathlonManEventListType;
        point: tetrathlonManEventListType;
      }[] = JSON.parse(storageData);

      console.log('parseData', parsedData);

      const selectedData = parsedData.find(
        (item) => item.name === selectedItem
      );

      if (selectedData) {
        // 選択されたデータが見つかった場合の処理
        console.log('Selected Data:', selectedData);
        setRecords(selectedData.data); // dataプロパティだけをセット
        setPoints(selectedData.point); // dataプロパティだけをセット
      }
    }

    setSelectedData(selectedItem);
    onCloseLoad();
  };

  return (
    <div>
      {/* <CustomHeader /> */}

      <div
        style={{ marginLeft: '100px', marginTop: '16px', marginBottom: '16px' }}
      >
        中学生男子四種競技得点表
      </div>
      <div style={{ display: 'flex', width: '360px', marginBottom: '10px' }}>
        <div style={{ marginLeft: '36px', width: '65%' }}>
          <HowToUse />
        </div>
        <Button
          onClick={reset}
          size="xs"
          style={{ color: 'black', backgroundColor: '#f5f5f5' }}
        >
          Reset
        </Button>
      </div>
      {eventList.map((eN, index) => {
        const color = index % 2 === 0 ? '#f5f5f5' : '#ffffff';
        return (
          <div style={{ backgroundColor: color }} key={index}>
            <ScoreInput
              title={eventNameDict[eN]}
              record={records[eN]}
              point={points[eN]}
              handleScoreChange={handleChange(eN)}
              totalScore={calcTotalPoint(eN)}
              handlePointChange={handlePointChangeParent(eN)}
            />
          </div>
        );
      })}

      <div style={{ backgroundColor: '#f5f5f5' }}>
        <div style={{ marginLeft: '16px' }}>---総合---</div>
        <div
          style={{
            display: 'flex',
            width: '360px',
            textAlign: 'center',
          }}
        >
          <div style={{ width: '30%', marginLeft: '10pt' }}>- </div>
          <div style={{ width: '30%', marginLeft: '10pt' }}>- </div>
          <div style={{ width: '20%', textAlign: 'right' }}>合計：</div>
          <div style={{ width: '20%', textAlign: 'right', marginRight: '1pt' }}>
            {calcTotalPoint('A00')} 点
          </div>
        </div>
      </div>
      {/* 下部のボタン部分の実装 */}
      <div style={{ marginTop: '10px', marginLeft: '20px' }}>
        <Flex justifyContent="space-between" maxWidth="300px">
          <Button size="xs" onClick={onOpenLoad}>
            Save/Load
          </Button>

          <Button
            onClick={reset}
            size="xs"
            style={{ color: 'black', backgroundColor: '#f5f5f5' }}
          >
            Reset
          </Button>
        </Flex>
      </div>

      {/* ロード用のモーダル */}
      <Modal isOpen={isOpenLoad} onClose={onCloseLoad}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Save/Load
            <div style={{ fontSize: '10px' }}>
              ※１週間アクセスがないとデータが消える場合があります
            </div>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div>
              <div>
                <Input
                  type="text"
                  value={inputName}
                  onChange={(e) => setInputName(e.target.value)}
                  // placeholder="例）2024年 日本選手権 予想"
                />
              </div>
              <div
                style={{
                  marginTop: '5px',
                  marginLeft: '10px',
                  marginRight: '10px',
                  display: 'flex',
                  justifyContent: 'space-between', // 要素の間にスペースを均等に配置
                  alignItems: 'center', // 要素を縦方向中央に配置
                }}
              >
                <div>
                  <HowToName />
                </div>

                <Button size="xs" onClick={saveData}>
                  名前を付けて保存
                </Button>
              </div>
              <br></br>
              <span style={{ fontSize: 12 }}>-データリスト-</span>
              <div>
                <UnorderedList>
                  {dataList.map((item, index) => (
                    <ListItem key={index} style={{ padding: '0px 0' }}>
                      {item}
                      &nbsp;
                      <Button
                        size="xs"
                        onClick={() => showSelectedData(item)}
                        style={{ marginRight: '5px', marginLeft: '5px' }}
                      >
                        Load
                      </Button>
                      &nbsp;
                      <Button size="xs" onClick={() => deleteData(item)}>
                        <DeleteIcon />
                      </Button>
                    </ListItem>
                  ))}
                </UnorderedList>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onCloseLoad}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <TextBox />

      <Links />
    </div>
  );
};
